
import { Plus } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface CreateCollectionCardProps {
  onClick: () => void;
}

export const CreateCollectionCard = ({ onClick }: CreateCollectionCardProps) => {
  return (
    <Card
      className="cursor-pointer group transition-all hover:scale-105 hover:ring-1 hover:ring-primary/50 dark:bg-card dark:shadow-none dark:border-0 max-w-[500px] w-full h-[240px]"
      onClick={onClick}
    >
      <CardContent className="p-4 flex flex-col items-center justify-center text-center h-full relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
        <div className="relative z-10">
          <div className="bg-primary/10 rounded-full p-3 mb-3 group-hover:bg-primary/20 transition-colors">
            <Plus className="w-6 h-6 text-primary" />
          </div>
          <h3 className="font-semibold text-lg text-primary">Create Collection</h3>
          <p className="text-sm text-muted-foreground mt-1 max-w-[200px] mx-auto">
            Start organizing your products in a new collection
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
